import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { AppCookiesService } from './app-cookies.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'sca-app-cookies',
  templateUrl: './app-cookies.component.html',
  styleUrls: ['./app-cookies.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class AppCookiesComponent {
  private _COOKIE_BANNER_PREFERENCES = 'Cookie_Banner_Preferences';
  private _ACCEPTED_PREFERENCE = 'accepted';

  public showCookiesBanner: boolean = false;
  public isReadMoreDisabled: boolean = false; // To avoid loading the cookies details multiple times

  constructor(private _cookiesService: CookieService,
    private _appCookiesService: AppCookiesService) { }

  public manageCookiesBanner(): void {
    let cookieBannerPreferencesValue = this._cookiesService.get(this._COOKIE_BANNER_PREFERENCES);

    if (cookieBannerPreferencesValue != this._ACCEPTED_PREFERENCE) {
      this.showCookiesBanner = true;
    }
  }

  public acceptCookies(): void {
    this._cookiesService.set(this._COOKIE_BANNER_PREFERENCES, this._ACCEPTED_PREFERENCE, 60, '/', undefined, true, "None");
    this.showCookiesBanner = false;
  }

  public readMore(): void {
    this.isReadMoreDisabled = true;

    this._appCookiesService.readMore().subscribe({
      next: () => this.isReadMoreDisabled = false
    });
  }

  public closeBanner(): void {
    this.showCookiesBanner = false;
  }
}
